import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || '/api';

// Criar instância do axios
const axiosInstance = axios.create({
  // baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Flag para evitar múltiplas tentativas de refresh simultâneas
let isRefreshing = false;
let failedQueue = [];

const processQueue = (error, token = null) => {
  failedQueue.forEach(prom => {
    if (error) {
      prom.reject(error);
    } else {
      prom.resolve(token);
    }
  });

  failedQueue = [];
};

// Request interceptor: Add access token and X-Customer-ID
axiosInstance.interceptors.request.use(
  (config) => {
    const accessToken = localStorage.getItem('beworks_access_token');

    if (accessToken) {
      config.headers.Authorization = `Bearer ${accessToken}`;
    }

    const isCustomerEndpoint = config.url?.includes('/customer/');
    const isBootstrapEndpoint = config.url?.includes('/collaborators/me');

    if (isCustomerEndpoint && !isBootstrapEndpoint) {
      const customerData = localStorage.getItem('beworks_customer');
      if (customerData) {
        try {
          const customer = JSON.parse(customerData);
          if (customer.uuid) {
            config.headers['X-Customer-ID'] = customer.uuid;
          }
        } catch (error) {
          console.error('Failed to parse customer data:', error);
        }
      }
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor: Handle token expiration and refresh
axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    const originalRequest = error.config;

    // If error is 401 and has access token, try to refresh
    if (
      error.response?.status === 401 &&
      !originalRequest._retry
    ) {
      const accessToken = localStorage.getItem('beworks_access_token');

      // Only try refresh if we have an access token
      if (!accessToken) {
        window.location.href = '/login';
        return Promise.reject(error);
      }
      if (isRefreshing) {
        return new Promise((resolve, reject) => {
          failedQueue.push({ resolve, reject });
        })
          .then(token => {
            originalRequest.headers.Authorization = `Bearer ${token}`;
            return axiosInstance(originalRequest);
          })
          .catch(err => {
            return Promise.reject(err);
          });
      }

      originalRequest._retry = true;
      isRefreshing = true;

      const refreshToken = localStorage.getItem('beworks_refresh_token');

      if (!refreshToken) {
        localStorage.removeItem('beworks_access_token');
        localStorage.removeItem('beworks_refresh_token');
        localStorage.removeItem('beworks_collaborator');
        localStorage.removeItem('beworks_customer');
        localStorage.removeItem('beworks_businesses');
        window.location.href = '/login';
        return Promise.reject(error);
      }

      try {
        const response = await axios.post(`${process.env.REACT_APP_AUTH_API_URL}/token/refresh/`, {
          refresh: refreshToken,
        });

        const { access } = response.data;

        localStorage.setItem('beworks_access_token', access);

        originalRequest.headers.Authorization = `Bearer ${access}`;

        processQueue(null, access);

        isRefreshing = false;

        return axiosInstance(originalRequest);
      } catch (refreshError) {
        processQueue(refreshError, null);
        isRefreshing = false;

        localStorage.removeItem('beworks_access_token');
        localStorage.removeItem('beworks_refresh_token');
        localStorage.removeItem('beworks_collaborator');
        localStorage.removeItem('beworks_customer');
        localStorage.removeItem('beworks_businesses');

        window.location.href = '/login';

        return Promise.reject(refreshError);
      }
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;
